// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"3efae223","106":"1a3d78e9","591":"c5ed37de","715":"0416229c","802":"61716e58","831":"b9932a5d","906":"7e52fef4"}[chunkId] + ".chunk.js";
};